export const actionTypes = {
    SET_ACTIVE_TAB: 'operationalParametersV2/SET_ACTIVE_TAB',
    DOWNLOAD_RAW_DATA: 'operationalParameters/DOWNLOAD_RAW_DATA',
    SET_DATE_SELECTION: 'overview/SET_DATE_SELECTION',
    SET_ACTIVE_TREND_TAB: 'operationalParameters/SET_ACTIVE_TREND_TAB',
    GET_SMART_SENSOR_LAST_COMMAND: 'operationalParameters/GET_SMART_SENSOR_LAST_COMMAND'
};

export const lastCommandRequestType = {
    loadMeasurementOnDemand: 'SmSeLoadMeasurementOnDemand',
    collectRawDataOnDemand: 'SmSeCollectRawDataOnDemand'
};

export const sensorLastCommandStatus = {
    PENDING: 'Pending',
    EXECUTING: 'Executing',
    SUCCESS: 'Success',
    CANCELLED: 'Cancelled',
    REJECTED: 'Rejected',
    ERROR: 'Error',
    TIMEOUT: 'Timeout'
};
export const dcuGeneration = {
    DCUGENERATION_PROPERTY: 'legacy'
};

export const histoScatterDateFormat = 'YYYY-MM-DD';
